import { PurchaseOrderGenericItem } from './purchase-order-generic-item';
import { PurchaseOrderProductItem } from './purchase-order-product-item';

export type PurchaseOrderItem = PurchaseOrderProductItem | PurchaseOrderGenericItem;

export const isPurchaseOrderProductItem = (
    purchaseOrderItem: PurchaseOrderItem
): purchaseOrderItem is PurchaseOrderProductItem => {
    return !isPurchaseOrderGenericItem(purchaseOrderItem);
};

export const isPurchaseOrderGenericItem = (invoiceItem: PurchaseOrderItem): invoiceItem is PurchaseOrderGenericItem => {
    return (invoiceItem as PurchaseOrderGenericItem).type !== undefined;
};

export const isFreePositionItem = (item: PurchaseOrderItem): boolean => {
    if (isPurchaseOrderProductItem(item)) {
        return item.isNormArticle || !item.product;
    }
    return false;
};
